import { FC, useEffect, memo, useState } from 'react'
import { useHelpers, useRemirrorContext } from '@remirror/react'

interface Props {
  getHtmlData?: boolean
  editorState: any
  updateData: (e: any, charCount?: number, plainText?: string) => void
  loadData: string
  preserveText?: boolean
}

export const EditorData: FC<Props> = ({
  editorState,
  getHtmlData,
  updateData,
  loadData,
  preserveText = true
}) => {
  const [updatedState, setUpdatedState] = useState(false)
  const { setContent } = useRemirrorContext()
  const { getHTML, getJSON, getText } = useHelpers()
  useEffect(() => {
    if (editorState) {
      const text = getText(editorState)
      if (!text || text?.trim() === '') {
        updateData('', 0, '')
      } else if (getHtmlData) {
        const fromEditorHtml = getHTML(editorState)
        updateData(fromEditorHtml, text.length, text)
      } else {
        const fromEditorJSON = getJSON(editorState)
        updateData(fromEditorJSON)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editorState])
  useEffect(() => {
    if (!preserveText) {
      return
    } else if (!updatedState && loadData && loadData !== '') {
      setContent(loadData)
      setUpdatedState(true)
    }
  }, [loadData, preserveText, setContent, updatedState])

  return null
}

export default memo(EditorData)
